// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3B1bP","location":"Header_location__rqBfu"};